import { AuthError, NetworkError, ValidationError, errorFromResponse } from "./errors.js";

export async function searchUniversal(query = "", options = {}) {
  const params = new URLSearchParams();
  if (query) params.set("q", query);
  if (options.limit) params.set("limit", String(options.limit));

  const url = `/api/search${params.toString() ? `?${params}` : ""}`;
  let response;
  try {
    response = await fetch(url, { credentials: "include" });
  } catch (error) {
    throw new NetworkError("Failed to reach universal search", error);
  }
  if (!response.ok) {
    const error = await errorFromResponse(response);
    throw error;
  }
  const payload = await response.json();
  if (!payload || !Array.isArray(payload.groups)) {
    throw new ValidationError("Universal search returned an invalid response");
  }
  return payload;
}

/**
 * Record a supported entity detail view for the current user. This is
 * intentionally separate from searchUniversal so navigation can remain
 * responsive if the best-effort analytics write is unavailable.
 */
export async function recordRecentView(type, id) {
  const response = await fetch("/api/search/recent-views", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ type, id }),
  });
  if (!response.ok) {
    throw await errorFromResponse(response);
  }
}

export async function removeRecentView(type, id) {
  const response = await fetch(
    `/api/search/recent-views/${encodeURIComponent(type)}/${encodeURIComponent(id)}`,
    { method: "DELETE", credentials: "include" },
  );
  if (!response.ok) {
    throw await errorFromResponse(response);
  }
}

export async function clearRecentViews() {
  const response = await fetch("/api/search/recent-views", {
    method: "DELETE",
    credentials: "include",
  });
  if (!response.ok) {
    throw await errorFromResponse(response);
  }
}